import type { ReactNode } from 'react';

import './fulfillment-options.scss';

type FulfillmentOptionsProps = Readonly<{
    children: ReactNode;
    'data-testid'?: string;
}>;

export const FulfillmentOptions = ({ children, 'data-testid': testId }: FulfillmentOptionsProps) => {
    return (
        <fieldset className="delivery-options" data-testid={testId}>
            {children}
        </fieldset>
    );
};
